/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { PublicUser } from "./user.entity";

export enum SearchRecordType {
  User = "user",
  Plate = "plate",
}

export interface BaseSearchResult {
  objectID: string;
  recordType: SearchRecordType;
  visible_by: string;
  createdAt: string;
}

export interface UserSearchResult extends BaseSearchResult {
  recordType: SearchRecordType.User;
  username: string;
  displayName: string;
  avatarUrl: string;
  bio: string;
  registeredWithUrbit: boolean;
}

export interface PlateSearchResult extends BaseSearchResult {
  recordType: SearchRecordType.Plate;
  title: string;
  user: PublicUser;
}

export type SearchResult = UserSearchResult | PlateSearchResult;
